module.exports = __webpack_public_path__ + "img/frio-logo-light.d594969e.png";